import ColorPicker from "@/pages/design/components/ColorPicker";
import Card from "@/pages/design/components/Card";
import CardItem from "@/pages/design/components/CardItem";
import { getURLFileName } from '@/pages/design/common/utils';
import draggable from "vuedraggable";
import YYImage from "@/pages/design/components/basic/image";
import no_img from '@/assets/noimg.png';
import FormEditPage from '@/pages/design/components/FormEditPage';
import { upload } from '@/services/common';
import SwiperHeightField from '@/pages/design/components/SwiperHeightField';
import InputBar from '@/pages/design/components/InputBar';
import ImgList from '@/pages/design/components/ImgList';
import InputBarSelect from "@/pages/design/components/InputBar/InputBarSelect.vue";
export default {
  i18n: require('../../design_i18n'),
  props: {
    value: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  components: {
    Card: Card,
    CardItem: CardItem,
    draggable: draggable,
    YYImage: YYImage,
    FormEditPage: FormEditPage,
    SwiperHeightField: SwiperHeightField,
    InputBar: InputBar,
    ImgList: ImgList,
    ColorPicker: ColorPicker,
    InputBarSelect: InputBarSelect
  },
  created: function created() {
    //  console.log('this', this)
  },
  data: function data() {
    return {
      form: this.$form.createForm(this),
      locationClient: [{
        label: this.$t('form.mobile'),
        value: 2
      }, {
        label: this.$t('form.pc'),
        value: 1
      }],
      /**
       * 下拉列表：大（479px），中（432px），小(316px)，自定义
       */
      pcHeight: [{
        label: '479',
        value: 479
      }, {
        label: '432 ',
        value: 432
      }, {
        label: '316',
        value: 316
      }],
      /**
       * 下拉列表：大(217px)、中(196px)、小(143px)，
       */
      mHeight: [{
        label: '217',
        value: 217
      }, {
        label: '196',
        value: 196
      }, {
        label: '143',
        value: 143
      }]
    };
  }
};